import { useMutation, useQueryClient } from 'react-query';
import {
  cancelSubscription,
  type CancelSubscriptionResponse,
  type CancelSubscriptionBody
} from '../../services/subscriptionService';

export function useCancelSubscription() {
  const queryClient = useQueryClient();
  return useMutation<
    CancelSubscriptionResponse,
    Error,
    { subscriptionId: string; body: CancelSubscriptionBody }
  >(({ subscriptionId, body }) => cancelSubscription(subscriptionId, body), {
    onSuccess: () => {
      queryClient.invalidateQueries(['mySubscription']);
    }
  });
}
